require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-ahrefs-bs-recharts.json") })
        }
      }, "path---package-ahrefs-bs-recharts");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-ahrefs-bs-recharts!./.cache/json/package-ahrefs-bs-recharts.json
// module id = 744
// module chunks = 231608221292675